import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const GET_ADDRESS_DETAILS = createRequestTypes('placement/trip/GET_ADDRESS_DETAILS');
export const GET_VIA_POINTS = createRequestTypes('placement/trip/GET_VIA_POINTS');
export const CREATE_VIA_POINT = createRequestTypes('placement/trip/CREATE_VIA_POINT');
export const EDIT_VIA_POINT = createRequestTypes('placement/trip/EDIT_VIA_POINT');
export const EDIT_START_POINT = createRequestTypes('placement/trip/EDIT_START_POINT');
export const EDIT_END_POINT = createRequestTypes('placement/trip/EDIT_END_POINT');
export const EDIT_LANE = createRequestTypes('placement/trip/EDIT_LANE');
export const DELETE_VIA_POINT = createRequestTypes('placement/trip/DELETE_VIA_POINT');
export const CREATE_NEW_ADDRESS = createRequestTypes('placement/trip/CREATE_NEW_ADDRESS');
export const EDIT_ADDRESS = createRequestTypes('placement/trip/EDIT_ADDRESS');
export const CLEAR_FLAGS = createRequestTypes('placement/trip/CLEAR_FLAGS');
export const DELETE_POC = createRequestTypes('placement/trip/DELETE_POC');
export const CLEAR_VIA_POINTS_LIST = createRequestTypes('placement/trip/CLEAR_VIA_POINTS_LIST');
export const GET_ADDRESS_DETAILS_V4 = createRequestTypes('placement/trip/GET_ADDRESS_DETAILS_V4');
export const CREATE_NEW_ADDRESS_V4 = createRequestTypes('placement/trip/CREATE_NEW_ADDRESS_V4');
export const SUBMIT_NEW_ADDRESSES_V4 = createRequestTypes('placement/trip/SUBMIT_NEW_ADDRESSES_V4');
export const DELETE_ADDRESS_V4 = createRequestTypes('placement/trip/DELETE_ADDRESS_V4');
export const UPDATE_ADDRESS = createRequestTypes('placement/trip/UPDATE_ADDRESS');
export const SELECT_MAP_LOCATION = createRequestTypes('placement/trip/SELECT_MAP_LOCATION');
export const SELECT_MAP_LOCATION_RESET = createRequestTypes('placement/trip/SELECT_MAP_LOCATION_RESET');

export const RESET_ADDRESS_CREATED = createRequestTypes('placement/trip/RESET_ADDRESS_CREATED');
export const getAddressDetails = {
  request: (params) => createAction(GET_ADDRESS_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_ADDRESS_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_ADDRESS_DETAILS[FAILURE], { response }),
};
export const getAddressDetailsV4 = {
  request: (params) => createAction(GET_ADDRESS_DETAILS_V4[REQUEST], { params }),
  success: (response) => createAction(GET_ADDRESS_DETAILS_V4[SUCCESS], { response }),
  failure: (response) => createAction(GET_ADDRESS_DETAILS_V4[FAILURE], { response }),
};
export const createNewAddressV4 = {
  request: (params) => createAction(CREATE_NEW_ADDRESS_V4[REQUEST], { params }),
  success: (response) => createAction(CREATE_NEW_ADDRESS_V4[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_NEW_ADDRESS_V4[FAILURE], { response }),
};
export const submitNewAddressesV4 = {
  request: (params) => createAction(SUBMIT_NEW_ADDRESSES_V4[REQUEST], { params }),
  success: (response) => createAction(SUBMIT_NEW_ADDRESSES_V4[SUCCESS], { response }),
  failure: (response) => createAction(SUBMIT_NEW_ADDRESSES_V4[FAILURE], { response }),
};
export const deleteAddressV4 = {
  request: (params) => createAction(DELETE_ADDRESS_V4[REQUEST], { params }),
  success: (response) => createAction(DELETE_ADDRESS_V4[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_ADDRESS_V4[FAILURE], { response }),
};

export const updateAddress = {
  request: (params) => createAction(UPDATE_ADDRESS[REQUEST], { params }),
  success: (response) => createAction(UPDATE_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_ADDRESS[FAILURE], { response }),
};
export const resetCreateAddress = {
  reset: () => createAction(RESET_ADDRESS_CREATED),
};
export const getViaPoints = {
  request: (params) => createAction(GET_VIA_POINTS[REQUEST], { params }),
  success: (response) => createAction(GET_VIA_POINTS[SUCCESS], { response }),
  failure: (response) => createAction(GET_VIA_POINTS[FAILURE], { response }),
  clearViaPointsList: () => createAction(CLEAR_VIA_POINTS_LIST),
};

export const createViaPoint = {
  request: (payload) => createAction(CREATE_VIA_POINT[REQUEST], { payload }),
  success: (response) => createAction(CREATE_VIA_POINT[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_VIA_POINT[FAILURE], { response }),
};

export const createNewAddress = {
  request: (payload) => createAction(CREATE_NEW_ADDRESS[REQUEST], { payload }),
  success: (response) => createAction(CREATE_NEW_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_NEW_ADDRESS[FAILURE], { response }),
};

export const editAddress = {
  request: (payload) => createAction(EDIT_ADDRESS[REQUEST], { payload }),
  success: (response) => createAction(EDIT_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_ADDRESS[FAILURE], { response }),
  clearFlags: () => createAction(CLEAR_FLAGS),
};

export const editViaPoint = {
  request: (payload) => createAction(EDIT_VIA_POINT[REQUEST], { payload }),
  success: (response) => createAction(EDIT_VIA_POINT[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_VIA_POINT[FAILURE], { response }),
};

export const deleteViaPoint = {
  request: (params) => createAction(DELETE_VIA_POINT[REQUEST], { params }),
  success: (response) => createAction(DELETE_VIA_POINT[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_VIA_POINT[FAILURE], { response }),
};

export const deletePoc = {
  request: (params) => createAction(DELETE_POC[REQUEST], { params }),
  success: (response) => createAction(DELETE_POC[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_POC[FAILURE], { response }),
};

export const editStartPoint = {
  request: (payload) => createAction(EDIT_START_POINT[REQUEST], { payload }),
  success: (response) => createAction(EDIT_START_POINT[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_START_POINT[FAILURE], { response }),
};

export const editEndPoint = {
  request: (payload) => createAction(EDIT_END_POINT[REQUEST], { payload }),
  success: (response) => createAction(EDIT_END_POINT[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_END_POINT[FAILURE], { response }),
};

export const editLane = {
  request: (payload) => createAction(EDIT_LANE[REQUEST], { payload }),
  success: (response) => createAction(EDIT_LANE[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_LANE[FAILURE], { response }),
};
export const selectMapLocation = {
  request: (params) => createAction(SELECT_MAP_LOCATION[REQUEST], { params }),
  success: (response) => createAction(SELECT_MAP_LOCATION[SUCCESS], { response }),
  failure: (response) => createAction(SELECT_MAP_LOCATION[FAILURE], { response }),
  reset: () => createAction(SELECT_MAP_LOCATION_RESET),
};
